import React, { Component } from 'react'
import './App.css'
import t from 'tcomb-form'
import logo from '../assets/Logo.png'
import googleBtn from '../assets/google_normal_button.svg'
import templates from './formTemplate'
import { withFirebase } from 'react-redux-firebase'
import { userActions } from '../actions/user.actions'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import classNames from 'classnames'
import { styles } from './dockPadStyle'
import CustomSnackbar from '../components/CustomSnackbar'
import Snackbar from '@material-ui/core/Snackbar'
import { alertActions } from '../actions/alert.actions'
var _ = require('lodash')

t.form.Form.templates = templates

const LoginSchema = t.struct({
  email: t.String, // a required string
  password: t.String // an optional number
})

const options = {
  fields: {
    password: {
      type: 'password'
    }
  }
}

class LoginScreen extends Component {
  handleSnackbarClose = (event, reason) => {
    this.props.dispatch(alertActions.clear())
  }

  onSubmit(evt) {
    evt.preventDefault()
    const v = this.refs.form.getValue()

    if (v) {
      const { dispatch } = this.props
      dispatch(userActions.login(v.email, v.password))
    }
  }

  handleGoogleLogin = e => {
    const { dispatch } = this.props
    dispatch(userActions.loginWithGoogle())
  }

  _renderGoogleButton() {
    return
    return (
      <Button
        onClick={this.handleGoogleLogin}
        style={{ padding: 0, marginTop: '10px' }}
        variant='contained'
        color='primary'>
        <img src={googleBtn} />
        <span style={{ padding: '0 10px', 'text-transform': 'none' }}>
          Sign in with Google
        </span>
      </Button>
    )
  }

  renderSignUpButton = () => {
    return
    return (
      <Button
        style={{ marginTop: '8px', color: '#4286dd' }}
        href='/signup'
        size='medium'>
        Don't have an account? Sign up
      </Button>
    )
  }

  render() {
    const { classes, alert } = this.props
    const alertMessage = !_.isEmpty(alert) ? alert.message : ''
    return (
      <form style={{ height: '100%' }} onSubmit={this.onSubmit.bind(this)}>
        <Snackbar
          open={!_.isEmpty(alert)}
          onClose={this.handleSnackbarClose}
          autoHideDuration={2000}>
          <CustomSnackbar
            onClose={this.handleSnackbarClose}
            variant='error'
            message={alertMessage}
          />
        </Snackbar>
        <div
          className={classNames(
            classes.loginBackgroundBackground,
            classes.rightBigForm
          )}>
          <Paper className='login-background'>
            <img src={logo} className='logo' />
            <div className='sign-in-to-your-acco'>
              <Typography variant='headline'>
                Sign In To Your Account
              </Typography>
            </div>
            <t.form.Form
              className='loginForm'
              ref='form'
              type={LoginSchema}
              options={options}
            />
            <Button variant='outlined' color='primary' type='submit'>
              {' '}
              Login{' '}
            </Button>
            {this._renderGoogleButton()}
            {this.renderSignUpButton()}
            
          </Paper>

        </div>
      </form>
    )
  }
}
export default compose(
  withFirebase,
  withRouter,
  withStyles(styles, { withTheme: true }),
  connect((state, props) => {
    return {
      alert: state.alert
    }
  })
)(LoginScreen)



// WEBPACK FOOTER //
// ./src/containers/LoginScreen.tsx